import { LoupeOutlined } from '@mui/icons-material';
import { Stack, Tooltip, useTheme } from '@mui/material';
import { Chip } from '@shared/components';
import { ReactNode } from 'react';

interface Props {
  activeColor: { bg: string; text: string };
  active: boolean | null;
  name: string;
  tooltipInfo?: string | ReactNode;
}

export function InsightReportValue({ activeColor, active, name, tooltipInfo }: Props) {
  const theme = useTheme();
  const { tint } = theme.vars.palette.semantic;

  const chipColor = active ? activeColor : { bg: tint.red.strong, text: tint.red.text };
  return tooltipInfo ? (
    <Tooltip title={tooltipInfo}>
      <Chip
        size="small"
        rounded
        backgroundColor={chipColor.bg}
        textColor={chipColor.text}
        label={
          <Stack justifyContent="space-between" flexDirection="row" alignItems="center">
            {name} <LoupeOutlined style={{ transform: 'rotate(90deg) scale(0.6)' }} />
          </Stack>
        }
      />
    </Tooltip>
  ) : (
    <Chip
      size="small"
      rounded
      backgroundColor={chipColor.bg}
      textColor={chipColor.text}
      label={name}
    />
  );
}
